export enum EntityStatusEnum {
  Inactive = 0,
  Active = 1
};
